import { create } from "zustand";

interface AuthStatusStore {
  isLoggedIn: boolean;
  setIsLoggedIn: (val: boolean) => void;
  logout: () => void;
}

export const useAuthStatus = create<AuthStatusStore>((set) => ({
  isLoggedIn: false,
  setIsLoggedIn: (val: boolean) => set(() => ({ isLoggedIn: val })),
  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("lt");
    set(() => ({ isLoggedIn: false }));
  },
}));
